import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useNavigateSearch } from '../../hooks/useNavigateSearch';
import { RoutePath } from '../../models/enums/RoutePath';

import { Log } from '../../utils/logger';

export const useAccessForbiddenPage = (resetErrorBoundary: () => void) => {
  const navigate = useNavigateSearch();
  const { pathname, state } = useLocation();

  const goToHomePage = () => {
    navigate(RoutePath.Home);
    resetErrorBoundary();
  };

  useEffect(() => {
    Log.warning(`Page (${pathname}) access forbidden. ${state}`);
  }, [pathname, state]);

  return { goToHomePage };
};
